import React from 'react';
import { atom } from '@reatom/framework';
import { useCtx } from '@reatom/npm-react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { getComponentDebugName } from '@/js/libs/reatom-devtools';
import { createObservableFromAtom } from './observable';
export function useState$(initialValue) {
    const ref = React.useRef(null);
    // eslint-disable-next-line react-hooks/refs
    if (!ref.current) {
        ref.current = atom(initialValue, getComponentDebugName('useState$'));
    }
    const { current } = ref;
    const ctx = useCtx();
    const setState = useCallbackRef((v) => {
        if (typeof v === 'function') {
            // @ts-expect-error I wish we don't use a function like the value
            current(ctx, (value) => v(value));
        }
        else {
            current(ctx, v);
        }
    });
    // eslint-disable-next-line react-hooks/refs
    const observable = React.useMemo(() => createObservableFromAtom(current), [current]);
    return [observable, setState];
}
